import React from 'react';
import { Footer, Navbar } from '../components';
import ProductFraudPage from "../components/ProductFraudPage";
import Seo from '../components/Seo';

function ProductFraud() {
    return (
        <div>
           <Seo
               title="Fraud Rules"
               description="The fraud rules WayaQuick applies to protect merchants and cardholders, including velocity checks, device, email and card blocking."
           />
           <Navbar />
            <ProductFraudPage/>
            <Footer />
        </div>
    )
}

export default ProductFraud
